export const Settings = {
    ProfileCompleted: 'ProfileCompleted',
}